export default __webpack_public_path__ + "static/media/partner-17.299e5f21.png";